import React, { useEffect, useState } from "react";
import "../Styles/Home.css";
import { Link } from "react-router-dom";
import {
  Service,
  FAQS,
  Process,
} from "../Components/IndexComponents";
import InformationModal from "../Components/InformationModal";
import { useLocation } from "react-router-dom";

function Home() {
  const [isInformationModalOpen, setIsInformationModalOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <>
      <div className="home_container">
        <div className="hero_content">
          <div
            data-aos="fade-right"
            data-aos-mirror="true"
            data-aos-once="false"
            data-aos-easing="ease-in-out"
            className="hero_text"
          >
            <p className="hero_kicker">Educational loan information</p>
            <h1 className="hero_title">
              Loan Information, Government Schemes <span>&amp; Application Guides</span>
            </h1>
            <p className="hero_description">
              PyLoan is an independent informational website that publishes
              educational articles about loans, eligibility criteria, required
              documents, application steps and government-supported business
              finance schemes. We do not provide, approve, arrange or guarantee
              loans.
            </p>
          </div>
          <div className="hero_btns">
            <Link className="btn hero_btn hero_btn_primary" to="/service">
              Explore Loan Guides <span aria-hidden="true">&#10132;</span>
            </Link>

            <Link className="btn hero_btn hero_btn_secondary" to="/about">
              About PyLoan <span aria-hidden="true">&#10132;</span>
            </Link>
            <button
              className="btn hero_btn hero_btn_secondary"
              type="button"
              onClick={() => setIsInformationModalOpen(true)}
            >
              Get More Information <span aria-hidden="true">&#10132;</span>
            </button>
          </div>
          <p className="hero_disclaimer">
            Information only. PyLoan does not accept or process loan applications.
          </p>
        </div>
      </div>
      <InformationModal
        isOpen={isInformationModalOpen}
        onClose={() => setIsInformationModalOpen(false)}
      />
      <Service />
      <FAQS />
      <Process />

      <section className="home_information_notice">
        <div className="home_information_notice_inner">
          <span className="home_notice_icon" aria-hidden="true">
            <i className="fa-solid fa-circle-info"></i>
          </span>
          <div>
            <h2>Use official sources for applications</h2>
            <p>
              PyLoan publishes general educational information only. For an
              application, eligibility decision or current scheme rule, use the
              relevant official government portal or contact a bank or financial
              institution directly.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
